var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"play-table",class:{ 'play-table--responsive': _vm.responsive }},[_c('table',{staticClass:"play-table__table",class:[
      {
        'play-table__table--hover': _vm.hover,
        'play-table__table--striped': _vm.striped,
        'play-table__table--bordered': _vm.bordered,
        'play-table__table--sm': _vm.small,
      } ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }